import { useEffect, useState, useContext } from "react";
import { Switch, useHistory, useRouteMatch } from "react-router-dom/cjs/react-router-dom";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom";


import { RouterBreadcrumbs } from "./EditDoctor/RouterBreadcrumbs";
import { DoctorProfileHeader } from "./EditDoctor/DoctorProfileHeader";
import { DoctorProfileForm } from "./EditDoctor/DoctorProfileForm";
import { DoctorSlot } from "./DoctorSchedule/DoctorSlot";
import { getDoctorDetails, getEntityRelationPropertyAPI } from "./Helper/API";
import { getProviderArray } from "./Helper/utils";
import { DoctorHolidays } from "./DoctorHolidays/doctorHolidayViewApply";
import { BackdropLoader } from "./BackdropLoader";
import { ToastEmitter } from "./ToastEmitter";
import { FEATURE_NAME, SOME_THING_WENT_WRONG } from "./constant"
import {checkFeatureFeasbility} from '../../helper/utils'
import UserFeaturesContext  from '../../hook/UserDetails/UserFeaturesContext'; // Import the context
import { getFeaturesForUser } from "../SPOC/Helper/utils";
import { UnauthorizedRBAC } from "../SPOC/UnauthorizedRBAC";

export const PageRouter = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingUserFeature, setIsLoadingUserFeature] = useState(false);
    let { path } = useRouteMatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const doctorId = queryParams.get('drId');
    const [doctorProfileDetails, setDoctorProfileDetails] = useState();
    const [entityRelationProperty, setEntityRelationProperty] = useState();
    const [QCEnableOnSlots, setQCEnableOnSlots] = useState(false);
    const { userFeatures, saveUserFeatures } = useContext(UserFeaturesContext);

    const getEntityRelationProperty = async () => {
        try {
            let providerArray = getProviderArray();
            const entityRelationPropertyRequestBody = {
                providerIds: providerArray,
                entityRelationPropertyByPropertyName: true,
                entityRelationPropertyNames: [
                    "MBCharge"
                ],
                operation: "AND"
            }
            const entityRelationProperty = await getEntityRelationPropertyAPI(entityRelationPropertyRequestBody)
            setEntityRelationProperty(entityRelationProperty?.data?.propertyList[0]);
        }
        catch (err) { }

    }
    const fetchDoctorProfileDetails = async (doctorId) => {
        try {
            setIsLoading(true);
            let providerArray = getProviderArray();
            let data = {
                providerIds: providerArray,
                doctorId: parseInt(doctorId, 10)
            }
            const resp = await getDoctorDetails(data);
            const entityRelationProperty = await getEntityRelationProperty();
            setDoctorProfileDetails(resp.data);
            setIsLoading(false);
        }
        catch (err) {
            ToastEmitter(SOME_THING_WENT_WRONG, 'error');
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!localStorage.getItem("access_token")) {
            history.push('/login')
        }
        if (doctorId) {
            fetchDoctorProfileDetails(doctorId);
        }
        else {
            getEntityRelationProperty();
        }
    }, [])

    useEffect(() => {
        const saveUserFeaturesInContextHook = async () => {
          if (userFeatures) return;
          setIsLoadingUserFeature(true);
          const {userFeature, userRoles} = await getFeaturesForUser(history)
          saveUserFeatures(userFeature, userRoles);
          setIsLoadingUserFeature(false);
    
        }
        saveUserFeaturesInContextHook();
      }, []);

    return (
        <div className="bg-[#ffffff]">
            {
                (isLoading || isLoadingUserFeature ) ? <BackdropLoader isLoading={isLoading || isLoadingUserFeature } /> :
                    <div className="flex flex-col px-8 py-4">
                        <nav className="flex flex-col">
                            <RouterBreadcrumbs />
                            {<DoctorProfileHeader doctorProfileDetails={doctorProfileDetails} />}
                        </nav>

                        <Switch>
                            <Route exact path={`${path}`}
                                render={() => {
                                    return checkFeatureFeasbility(FEATURE_NAME.CREATE_DOCTOR, userFeatures) ?
                                        <DoctorProfileForm setDoctorProfileDetails={setDoctorProfileDetails} doctorProfileDetails={doctorProfileDetails} entityRelationProperty={entityRelationProperty} QCEnableOnSlots={QCEnableOnSlots} setQCEnableOnSlots={setQCEnableOnSlots} />
                                        : <UnauthorizedRBAC/>
                                }}
                            />
                            <Route exact path={`${path}/Schedule`}
                                render={() => {
                                    return  checkFeatureFeasbility(FEATURE_NAME.CREATE_DOCTOR, userFeatures) ?
                                        <DoctorSlot setDoctorProfileDetails={setDoctorProfileDetails} doctorProfileDetails={doctorProfileDetails} QCEnableOnSlots={QCEnableOnSlots} />
                                        : <UnauthorizedRBAC/>
                                }} />
                            <Route exact path={`${path}/Holidays`} 
                            render={() => {
                                return checkFeatureFeasbility(FEATURE_NAME.CREATE_DOCTOR, userFeatures) ?
                                        <DoctorHolidays doctorProfileDetails={doctorProfileDetails} /> 
                                        : <UnauthorizedRBAC/>
                                }} />
                        </Switch>
                    </div>
            }

        </div>
    )
}
